import React from "react";
import { useSelector } from "react-redux";
import { List } from "@material-ui/core";
import translate from "i18n/translate";
import { Typography } from "components/common";
import { getRoutesPropsWithParentsTree } from "routes/getRoutesProps";
import portalRoutesConfig from "routes/portal/portalRoutesConfig";
import MenuItem from "./MenuItem";
import { useStyles } from "./sideBarStyles";

const MenuItemsTree = ({ onMenuItemClick }) => {
  const classes = useStyles();
  const { role, user } = useSelector(({ auth }) => auth);
  const getRoutesPropsParams = {
    route: portalRoutesConfig(),
    role,
    permissions: user.permissions,
  };

  const routesPropsWithParentsTree =
    getRoutesPropsWithParentsTree(getRoutesPropsParams);

  const MenuItems = ({ menuItems }) =>
    menuItems.map(({ label, path, icon }) => (
      <MenuItem
        key={`menu-item-${label}`}
        label={label}
        path={path}
        Icon={icon}
        onMenuItemClick={onMenuItemClick}
      />
    ));

  return routesPropsWithParentsTree.map(
    (parentRouteProps) =>
      !!parentRouteProps.children.length && (
        <div key={parentRouteProps.label || parentRouteProps.children[0].label}>
          <Typography variant="h5" className={classes.parentItem}>
            {parentRouteProps.label ? translate(parentRouteProps.label) : ""}
          </Typography>
          <List>
            <MenuItems menuItems={parentRouteProps.children} />
          </List>
        </div>
      )
  );
};

export default MenuItemsTree;
